"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captchaApi = captchaApi;
exports.captchaconfigApi = captchaconfigApi;
exports.foundsApi = foundsApi;
exports.getInfo = getInfo;
exports.getLoginPicApi = getLoginPicApi;
exports.getSendLists = getSendLists;
exports.groupDeleteApi = groupDeleteApi;
exports.groupInfoApi = groupInfoApi;
exports.groupListApi = groupListApi;
exports.groupPiApi = groupPiApi;
exports.groupSaveApi = groupSaveApi;
exports.groupUpdateApi = groupUpdateApi;
exports.infobyconditionApi = infobyconditionApi;
exports.levelDeleteApi = levelDeleteApi;
exports.levelInfoApi = levelInfoApi;
exports.levelListApi = levelListApi;
exports.levelSaveApi = levelSaveApi;
exports.levelUpdateApi = levelUpdateApi;
exports.levelUseApi = levelUseApi;
exports.login = login;
exports.logout = logout;
exports.searchDetail = searchDetail;
exports.searchTemps = searchTemps;
exports.sendCouponDetail = sendCouponDetail;
exports.sendCouponFailDetail = sendCouponFailDetail;
exports.sendCoupons = sendCoupons;
exports.sendUserMessages = sendUserMessages;
exports.tagDeleteApi = tagDeleteApi;
exports.tagInfoApi = tagInfoApi;
exports.tagListApi = tagListApi;
exports.tagPiApi = tagPiApi;
exports.tagSaveApi = tagSaveApi;
exports.tagUpdateApi = tagUpdateApi;
exports.topdetailApi = topdetailApi;
exports.updatePhoneApi = updatePhoneApi;
exports.updateSpreadApi = updateSpreadApi;
exports.userDeleteApi = userDeleteApi;
exports.userInfoApi = userInfoApi;
exports.userLevelUpdateApi = userLevelUpdateApi;
exports.userListApi = userListApi;
exports.userStatusUpdateApi = userStatusUpdateApi;
exports.userUpdateApi = userUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function login(data) {
  return (0, _request.default)({
    url: '/admin/login',
    method: 'post',
    data: data
  });
}
function getInfo(token) {
  return (0, _request.default)({
    url: '/admin/getAdminInfoByToken',
    method: 'get',
    params: {
      token: token
    }
  });
}
function logout() {
  return (0, _request.default)({
    url: '/admin/logout',
    method: 'get'
  });
}

/**
 * 会员管理 列表
 * @param pram
 */
function userListApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/user/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 修改
 * @param pram
 */
function userUpdateApi(params, data) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/user/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员管理 状态修改
 * @param pram
 */
function userStatusUpdateApi(params) {
  return (0, _request.default)({
    url: "/admin/user/update/status",
    method: 'post',
    params: params
  });
}

/**
 * 会员管理等级 修改
 * @param pram
 */
function userLevelUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/user/update/level",
    method: 'post',
    data: data
  });
}

/**
 * 会员管理 详情
 * @param pram
 */
function userInfoApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/user/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情
 * @param pram
 */
function infobyconditionApi(params) {
  return (0, _request.default)({
    url: "/admin/user/infobycondition",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情top数据
 * @param pram
 */
function topdetailApi(params) {
  return (0, _request.default)({
    url: "/admin/user/topdetail",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 批量设置分组
 * @param pram
 */
function groupPiApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/user/group",
    method: 'post',
    params: params
  });
}

/**
 * 会员管理 批量设置标签
 * @param pram
 */
function tagPiApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/user/tag",
    method: 'post',
    params: params
  });
}

/**
 * 会员管理 积分余额
 * @param pram
 */
function foundsApi(params) {
  return (0, _request.default)({
    url: "/admin/user/operate/founds",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 删除
 * @param pram
 */
function userDeleteApi(params) {
  return (0, _request.default)({
    url: "/admin/user/delete",
    method: 'get',
    params: params
  });
}

/**
 * 会员等级 列表
 * @param pram
 */
function levelListApi() {
  return (0, _request.default)({
    url: "/admin/system/user/level/list",
    method: 'get'
  });
}

/**
 * 会员等级 新增
 * @param pram
 */
function levelSaveApi(data) {
  return (0, _request.default)({
    url: "/admin/system/user/level/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员等级 编辑
 *  @param pram
 */
function levelUpdateApi(params, data) {
  return (0, _request.default)({
    url: "/admin/system/user/level/update/".concat(params),
    method: 'post',
    // params,
    data: data
  });
}

/**
 * 会员等级 详情
 * @param pram
 */
function levelInfoApi(params) {
  return (0, _request.default)({
    url: "/admin/system/user/level/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员等级 删除
 * @param pram
 */
function levelDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/system/user/level/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 会员等级 是否显示
 * @param pram
 */
function levelUseApi(data) {
  return (0, _request.default)({
    url: "/admin/system/user/level/use",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 列表
 * @param pram
 */
function tagListApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userTag/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 新增
 * @param pram
 */
function tagSaveApi(data) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userTag/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 编辑
 * @param pram
 */
function tagUpdateApi(params, data) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userTag/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员标签 详情
 * @param pram
 */
function tagInfoApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userTag/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 删除
 * @param pram
 */
function tagDeleteApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userTag/delete",
    method: 'get',
    params: params
  });
}

/**
 * 会员分组 列表
 * @param pram
 */
function groupListApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userGroup/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员分组 新增
 * @param pram
 */
function groupSaveApi(data) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userGroup/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员分组 编辑
 * @param pram
 */
function groupUpdateApi(params, data) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userGroup/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员分组 详情
 * @param pram
 */
function groupInfoApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userGroup/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员分组 删除
 * @param pram
 */
function groupDeleteApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/userGroup/delete",
    method: 'get',
    params: params
  });
}

/**
 *获取登录页图片
 */
function getLoginPicApi() {
  return (0, _request.default)({
    url: "/admin/getLoginPic",
    method: 'get'
  });
}

/**
 * @description 验证码
 */
function captchaApi() {
  return (0, _request.default)({
    url: "/admin/validate/code/get",
    method: 'get'
  });
}

/**
 * @description 修改上级推广人
 */
function updateSpreadApi(data) {
  return (0, _request.default)({
    url: "/admin/user/update/spread",
    method: 'post',
    data: data
  });
}

/**
 * @description 修改手机号
 */
function updatePhoneApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/user/update/phone",
    method: 'get',
    params: params
  });
}

/**
 * 查询是否需要开启图形验证码
 * @returns {*}
 */
function captchaconfigApi() {
  return (0, _request.default)({
    url: "/admin/validate/code/getcaptchaconfig",
    method: 'get'
  });
}

/**
 * 发送优惠券
 */
function sendCoupons(data) {
  return (0, _request.default)({
    url: "/admin/coupons/issuance/send",
    method: 'post',
    data: data
  });
}

/**
 * 发放优惠券明细
 */
function sendCouponDetail(params, issuanceId) {
  return (0, _request.default)({
    url: "/admin/coupons/issuance/".concat(issuanceId, "/detail"),
    method: 'get',
    params: params
  });
}

/**
 * 发放优惠券失败明细
 */
function sendCouponFailDetail(params, issuanceId) {
  return (0, _request.default)({
    url: "/admin/coupons/issuance/".concat(issuanceId, "/failDetail"),
    method: 'get',
    params: params
  });
}

/**
 * 发放优惠券记录列表
 */
function getSendLists(params) {
  return (0, _request.default)({
    url: "/admin/coupons/issuance/issuanceRecords",
    method: 'get',
    params: params
  });
}

/**
 * 用户列表发送消息
 */
function sendUserMessages(data) {
  return (0, _request.default)({
    url: "/admin/users/send-notification",
    method: 'post',
    data: data
  });
}

/**
 * 查询消息模版
 */
function searchTemps(params) {
  return (0, _request.default)({
    url: "/admin/templates/search",
    method: 'get',
    params: params
  });
}

/**
 * 会员详情列表
 */
function searchDetail(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/user/detail",
    method: 'get',
    params: params
  });
}